import { Close as CloseIcon } from "@mui/icons-material"
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogProps,
  DialogTitleProps,
  DialogContentProps,
  DialogActions,
  DialogActionsProps,
} from "@mui/material"

export interface IModalProps<T extends any = any>
  extends Omit<DialogProps, "children" | "open"> {
  title: string
  onClose?: () => void
  open?: boolean
  /** Запретить закрытие по клику вне окна и по Escape (закрытие только через крест). */
  disableBackdropClose?: boolean
  dialogProps?: Partial<DialogProps>
  dialogTitleProps?: Partial<DialogTitleProps>
  dialogContentProps?: Partial<DialogContentProps>
  actions?: JSX.Element[]
  dialogActionsProps?: Partial<DialogActionsProps>
  childrenProps?: T
}
interface IModalChildrenProps extends IModalProps {
  children: React.ReactElement
}
interface IModalElementProps extends IModalProps {
  element: React.ReactElement
}
type ModalProps = IModalChildrenProps | IModalElementProps

export function Modal({
  title,
  onClose,
  open,
  disableBackdropClose,
  dialogTitleProps,
  dialogContentProps,
  dialogActionsProps,
  dialogProps,
  childrenProps,
  ...props
}: ModalProps) {
  const handleDialogClose: DialogProps["onClose"] = (event, reason) => {
    if (
      disableBackdropClose &&
      (reason === "backdropClick" || reason === "escapeKeyDown")
    ) {
      return
    }
    onClose?.()
  }

  return (
    <Dialog
      open={open ?? true}
      onClose={handleDialogClose}
      fullWidth
      maxWidth={"sm"}
      {...dialogProps}
    >
      <DialogTitle {...dialogTitleProps}>
        {title}
        {onClose && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent {...dialogContentProps}>
        {"children" in props ? props.children : props.element}
      </DialogContent>
      {!!props.actions?.length && (
        <DialogActions {...dialogActionsProps}>
          {...props.actions}
        </DialogActions>
      )}
    </Dialog>
  )
}
